export default __webpack_public_path__ + "blitz-logo-contained-e6ae5fc40a6ef393877b1add65d378bc.svg";